<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{data.title}}</h4>
    <div mat-dialog-content class="dialog-content text-muted" *ngIf="!isAccountLoading">
        <form *ngIf="!active" [formGroup]="loginForm" class="login-form row" (ngSubmit)="verifyDevice()">
            <mat-form-field class="example-full-width col-12" appearance="outline">
                <input matInput formControlName="RAMP_username" placeholder="Username" type="text">
            </mat-form-field>
            <mat-form-field class="example-full-width col-12" appearance="outline">
                <input matInput formControlName="Password" placeholder="Password" autocomplete="password"
                    [type]="hide ? 'password' : 'text'">
                <button mat-icon-button matSuffix [disabled]="active" (click)="hidePassword()"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                    <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
            </mat-form-field>
            <div class="row col-12 p-0">
                <button class="cancel-button" type="submit"
                    *ngIf="!isLoading; else loadingTemplate">Connect</button>

                <ng-template #loadingTemplate>
                    <button type="button" class="cancel-button" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </button>
                </ng-template>
            </div>
        </form>
        <div *ngIf="active" class="d-flex align-items-center justify-content-between">
            <span><strong>Account:</strong> {{username}}</span>
            <button class="logout-button" (click)="logoutAccount(username)" type="submit"
                *ngIf="!isLoading; else loadingTemplate">Logout</button>

            <ng-template #loadingTemplate>
                <button type="button" class="logout-button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
            </ng-template>
        </div>
        <div *ngIf="active" class="d-flex align-items-center justify-content-between mt-3">
            <span><strong>OTP:</strong> {{OTP}}</span>
            <button [ngClass]="countdown > 0 ? 'disabled-button' : 'yes-button'"  type="submit" (click)="regenerateOTP()" [disabled]="countdown > 0">
                <ng-container *ngIf="countdown > 0; else resendText">
                    {{formatCountdown()}}
                </ng-container>
                <ng-template #resendText>Resend</ng-template>
            </button>
        </div>
    </div>
    <div mat-dialog-content *ngIf="isAccountLoading" class="loading-container">
        <mat-spinner></mat-spinner>
        <p>Fetching account details...</p>
    </div>
    <div mat-dialog-actions *ngIf="!isAccountLoading"
        class="dialog-actions mt-4 d-flex align-items-center justify-content-between">
        <a class="back-button" (click)="onNoClick()">Cancel</a>
        <a class="yes-button" [href]="getDynamicUrl()" (click)="onClick()" target="_blank">Go To App</a>
    </div>
</div>